import styled from "@emotion/styled"
import { ShadowContainer } from "../../../../styled/layout.styled"

type IdeaCreateRecommendationContainerProps = {
  hidden: boolean
}

export const IdeaCreateRecommendationContainer = styled(ShadowContainer)(
  (props: IdeaCreateRecommendationContainerProps) => ({
    padding: "10px",
    display: props.hidden ? "none" : "flex",
  }),
)
